export default __webpack_public_path__ + "static/Student Uniform and Grooming Policy-242b475501afcb74cf385ce9488ba518.pdf";